{
  "familyId": "TAA-LEZEN-STRUCTUUR",
  "questions": [
    {
      "id": "TAA-LEZEN-STRUCTUUR-001",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Een tekst beschrijft eerst het probleem van plastic in de oceaan, en daarna mogelijke oplossingen. Welke tekststructuur is dit?",
      "options": ["Probleem-oplossing", "Oorzaak-gevolg", "Vergelijking", "Chronologisch"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Tekststructuren", "content": "Probleem-oplossing: eerst het probleem, dan de oplossing. Oorzaak-gevolg: iets gebeurt, daardoor iets anders. Vergelijking: twee dingen naast elkaar. Chronologisch: op volgorde van tijd.", "icon": "lightbulb"}}],
      "conceptId": "structuur_probleem_oplossing",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De tekst beschrijft eerst een probleem (plastic in de oceaan) en daarna oplossingen. Dit is de probleem-oplossingstructuur.",
        "solutionSteps": ["Eerst: probleem (plastic in oceaan)", "Daarna: oplossingen", "Structuur = probleem-oplossing"],
        "distractorExplanations": {
          "0": "Goed! Probleem + oplossing = probleem-oplossingstructuur.",
          "1": "Je dacht waarschijnlijk aan oorzaak-gevolg. Maar bij oorzaak-gevolg gaat het om wat er gebeurt door iets anders. Hier gaat het om een probleem en hoe je het kunt oplossen. Onthoud: probleem + oplossing ≠ oorzaak + gevolg.",
          "2": "Je dacht waarschijnlijk aan vergelijking. Maar er worden geen twee dingen vergeleken. Er wordt één probleem beschreven met oplossingen. Onthoud: vergelijking = twee dingen naast elkaar zetten.",
          "3": "Je dacht waarschijnlijk aan chronologisch. Maar de tekst volgt geen tijdsvolgorde van gebeurtenissen. Onthoud: chronologisch = op volgorde van tijd (eerst... toen... daarna...)."
        }
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-002",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord past bij een oorzaak-gevolgstructuur?",
      "options": ["daardoor", "ten eerste", "in tegenstelling tot", "ten slotte"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Signaalwoorden per structuur", "content": "Oorzaak-gevolg: daardoor, hierdoor, als gevolg van, doordat. Opsomming: ten eerste, ten tweede. Tegenstelling: in tegenstelling tot, maar, echter. Chronologisch: ten slotte, daarna.", "icon": "lightbulb"}}],
      "conceptId": "structuur_signaalwoorden",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Daardoor' geeft een gevolg aan: iets gebeurt, daardoor iets anders. Dit past bij oorzaak-gevolg.",
        "solutionSteps": ["Daardoor = gevolg-signaalwoord", "Past bij oorzaak-gevolgstructuur"],
        "distractorExplanations": {
          "0": "Goed! 'Daardoor' is een signaalwoord voor oorzaak-gevolg.",
          "1": "Je dacht waarschijnlijk dat 'ten eerste' bij oorzaak-gevolg hoort. Maar 'ten eerste' is een opsommingssignaalwoord. Onthoud: ten eerste/ten tweede = opsomming.",
          "2": "Je dacht waarschijnlijk dat 'in tegenstelling tot' bij oorzaak-gevolg hoort. Maar dat is een tegenstellingssignaalwoord. Onthoud: in tegenstelling tot = vergelijking/tegenstelling.",
          "3": "Je dacht waarschijnlijk dat 'ten slotte' bij oorzaak-gevolg hoort. Maar 'ten slotte' geeft het einde van een reeks aan. Onthoud: ten slotte = opsomming of chronologisch."
        }
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-003",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Een tekst vergelijkt het leven in de stad met het leven op het platteland. Welke tekststructuur is dit?",
      "options": ["Vergelijking", "Opsomming", "Probleem-oplossing", "Oorzaak-gevolg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Vergelijkingsstructuur", "content": "Bij een vergelijking worden twee dingen naast elkaar gezet. Signaalwoorden: in vergelijking met, terwijl, daarentegen, enerzijds... anderzijds.", "icon": "lightbulb"}}],
      "conceptId": "structuur_vergelijking",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De tekst zet twee dingen naast elkaar: stad vs platteland. Dit is een vergelijkingsstructuur.",
        "solutionSteps": ["Twee dingen worden vergeleken: stad en platteland", "Structuur = vergelijking"],
        "distractorExplanations": {
          "0": "Goed! Stad vs platteland = vergelijkingsstructuur.",
          "1": "Je dacht waarschijnlijk aan opsomming. Maar bij opsomming worden punten opgesomd, niet twee dingen vergeleken. Onthoud: vergelijking = twee dingen naast elkaar.",
          "2": "Je dacht waarschijnlijk aan probleem-oplossing. Maar er wordt geen probleem beschreven met een oplossing. Er worden twee leefomgevingen vergeleken.",
          "3": "Je dacht waarschijnlijk aan oorzaak-gevolg. Maar er wordt geen oorzaak met een gevolg verbonden. Er worden twee dingen naast elkaar gezet."
        }
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-004",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "multiple_choice",
      "question": "Een tekst over de Tweede Wereldoorlog beschrijft gebeurtenissen van 1939 tot 1945. Welke structuur heeft deze tekst?",
      "options": ["Chronologisch", "Oorzaak-gevolg", "Vergelijking", "Probleem-oplossing"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Chronologische structuur", "content": "Chronologisch = op volgorde van tijd. Signaalwoorden: eerst, daarna, vervolgens, ten slotte, in 1940, later.", "icon": "lightbulb"}}],
      "conceptId": "structuur_chronologisch",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De tekst beschrijft gebeurtenissen op volgorde van tijd (1939 tot 1945). Dit is een chronologische structuur.",
        "solutionSteps": ["Gebeurtenissen op tijdsvolgorde: 1939 → 1945", "Structuur = chronologisch"],
        "distractorExplanations": {
          "0": "Goed! Op volgorde van tijd = chronologisch.",
          "1": "Je dacht waarschijnlijk aan oorzaak-gevolg. Hoewel oorlogsgebeurtenissen oorzaken en gevolgen hebben, is de hoofdstructuur hier chronologisch (op tijdsvolgorde). Onthoud: als de nadruk op tijdsvolgorde ligt → chronologisch.",
          "2": "Je dacht waarschijnlijk aan vergelijking. Maar er worden geen twee dingen vergeleken. De tekst volgt een tijdlijn.",
          "3": "Je dacht waarschijnlijk aan probleem-oplossing. Hoewel oorlog een probleem is, beschrijft deze tekst gebeurtenissen op volgorde, niet een probleem met oplossingen."
        }
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-005",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "matching",
      "question": "Koppel elke tekststructuur aan het juiste signaalwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {"leftItems": ["Oorzaak-gevolg", "Vergelijking", "Opsomming", "Chronologisch"], "rightItems": ["ten eerste", "daardoor", "vervolgens", "in tegenstelling tot"], "correctMatches": {"0": 1, "1": 3, "2": 0, "3": 2}},
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Signaalwoorden per structuur", "content": "Oorzaak-gevolg: daardoor. Vergelijking: in tegenstelling tot. Opsomming: ten eerste. Chronologisch: vervolgens.", "icon": "lightbulb"}}],
      "conceptId": "structuur_signaalwoorden_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Oorzaak-gevolg → daardoor. Vergelijking → in tegenstelling tot. Opsomming → ten eerste. Chronologisch → vervolgens.",
        "solutionSteps": ["Oorzaak-gevolg: daardoor (gevolg-woord)", "Vergelijking: in tegenstelling tot (contrast-woord)", "Opsomming: ten eerste (volgorde-woord)", "Chronologisch: vervolgens (tijd-woord)"]
      }
    },
    {
      "id": "TAA-LEZEN-STRUCTUUR-006",
      "familyId": "TAA-LEZEN-STRUCTUUR",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "tekstbegrip",
      "subSkill": "tekst_structuur",
      "questionType": "true_false_series",
      "question": "Beoordeel elke stelling over tekststructuren: waar of niet waar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {"text": "Bij een oorzaak-gevolgstructuur beschrijft de tekst eerst wat er gebeurt en daarna waarom.", "isTrue": true},
          {"text": "Het signaalwoord 'ten eerste' hoort bij een chronologische structuur.", "isTrue": false},
          {"text": "Bij een vergelijkingsstructuur worden twee of meer dingen naast elkaar gezet.", "isTrue": true},
          {"text": "Een probleem-oplossingstructuur begint altijd met de oplossing.", "isTrue": false}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tekststructuren — overzicht",
            "content": "Oorzaak-gevolg: oorzaak → gevolg (signaalwoord: daardoor). Opsomming: ten eerste, ten tweede (niet chronologisch!). Vergelijking: twee dingen naast elkaar. Probleem-oplossing: eerst probleem, dan oplossing.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "structuur_true_false",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Stelling 1: WAAR — oorzaak-gevolg beschrijft wat er gebeurt (oorzaak) en het gevolg. Stelling 2: NIET WAAR — 'ten eerste' hoort bij opsomming, niet chronologisch. Stelling 3: WAAR — vergelijking zet twee dingen naast elkaar. Stelling 4: NIET WAAR — probleem-oplossing begint met het probleem, niet de oplossing.",
        "solutionSteps": [
          "Stelling 1: oorzaak-gevolg = oorzaak → gevolg → WAAR",
          "Stelling 2: 'ten eerste' = opsomming, niet chronologisch → NIET WAAR",
          "Stelling 3: vergelijking = twee dingen naast elkaar → WAAR",
          "Stelling 4: probleem-oplossing begint met probleem → NIET WAAR"
        ]
      }
    }
  ]
}